import tw from "twin.macro";

export const Heading = tw.h2`leading-tight text-center text-2xl uppercase text-blue-900 font-bold my-8`;
export const SubHeading = tw.h3`leading-tight text-lg font-bold mb-4`;
export const ContainerBase = tw.div`p-6 my-6`;
export const Container = tw(ContainerBase)`rounded shadow-lg bg-white`;
export const Paragraph = tw.p`mb-4`;
export const Hyperlink = tw.a`text-blue-900 hocus:text-blue-700 hocus:underline`;
